import { Box, Thumbnail } from '@wix/design-system';
import { LayoutThreeColumns, LayoutTwoColumns } from '@wix/wix-ui-icons-common';
import React, { useContext } from 'react';

import { EditorContext, ModalServiceContext, RicosContext } from './../../../ricos-context';
import { useBiNext } from './../../../_shared/bi-context-provider/bi-context-provider';
import { Panel, PanelHeader } from './../../../ui-components';

import {
  INSERT_LAYOUT_MODAL,
  INSERT_LAYOUT_MODAL_THREE_COLUMNS,
  INSERT_LAYOUT_MODAL_TWO_COLUMNS,
} from '../data-hooks';

export const LAYOUT_INSERT_MODAL_ID = 'layout-insert-modal';

export const LayoutInsertModal: React.FC = () => {
  const { t } = React.useContext(RicosContext);
  const { adapter } = useContext(EditorContext);
  const modalService = React.useContext(ModalServiceContext) || {};
  const logBi = useBiNext({ pluginId: 'layout', modalId: LAYOUT_INSERT_MODAL_ID });

  const closeModal = () => modalService.closeModal(LAYOUT_INSERT_MODAL_ID);

  const onLayoutSelected = (colCount: number) => {
    adapter.tiptapEditor.commands.insertLayout(colCount);
    closeModal();
  };

  return (
    <Panel dataHook={INSERT_LAYOUT_MODAL} onCloseButtonClick={closeModal} height="100%">
      <PanelHeader title={t('Layout_InsertModal_Header_Title')} />

      <Box
        direction="horizontal"
        paddingTop="SP4"
        paddingBottom="SP4"
        paddingLeft="SP3"
        paddingRight="SP3"
        align="space-between"
      >
        <Thumbnail
          title={t('Layout_InsertModal_2Columns')}
          dataHook={INSERT_LAYOUT_MODAL_TWO_COLUMNS}
          image={<LayoutTwoColumns />}
          height={90}
          width={122}
          size="tiny"
          contentAlignment="center"
          onClick={() => {
            logBi({ dataHook: INSERT_LAYOUT_MODAL_TWO_COLUMNS });
            onLayoutSelected(2);
          }}
        />
        <Thumbnail
          title={t('Layout_InsertModal_3Columns')}
          dataHook={INSERT_LAYOUT_MODAL_THREE_COLUMNS}
          image={<LayoutThreeColumns />}
          height={90}
          width={122}
          size="tiny"
          contentAlignment="center"
          onClick={() => {
            logBi({ dataHook: INSERT_LAYOUT_MODAL_THREE_COLUMNS });
            onLayoutSelected(3);
          }}
        />
      </Box>
    </Panel>
  );
};
